import React, { useState } from 'react'
import { useSelector } from "react-redux";
import { send } from "@emailjs/browser";
import "./Contact.css";
import Navbar from '../../Common/Navbar/Navbar';
import Footer from '../../Common/Footer/Footer';
function Contact() {
  const slice = useSelector((state) => state.functionslice.value);
  /* FAQ Data */
  const faqs = [
    {
      question: "What types of smart city solutions do you offer?",
      answer: "We offer comprehensive solutions including Intelligent Traffic Management, ANPR, Public Transit Optimization, Smart Parking Management Systems, Passenger Information Systems (PIS), vehicle analytics, and Crowd Prediction & Management platforms powered by advanced AI."
    },
    {
      question: "Do you provide customized AI solutions?",
      answer: "Yes, we specialize in designing and deploying tailored AI and computer vision systems based on specific city, highway, transport corporation, or institutional requirements."
    },
    {
      question: "Who are your typical clients?",
      answer: "Our clients include government agencies, smart city missions, transport corporations, highway authorities, research institutions, and private mobility operators."
    },
    {
      question: "What technologies power your systems?",
      answer: "Our systems leverage Artificial Intelligence, Computer Vision, Deep Learning, Edge AI, IoT-enabled devices, vehicle tracking technologies, predictive analytics, and real-time data processing frameworks."
    },
    {
      question: "What makes Parimitra different from other technology providers?",
      answer: "We focus on edge-optimized AI solutions that are research-backed, scalable, and designed for real-world deployment rather than just prototypes, ensuring reliability, affordability, and measurable impact."
    },
    {
      question: "How long does implementation typically take?",
      answer: "Implementation timelines vary depending on project scope, but pilot deployments can typically be completed within 1-2 weeks using our modular and scalable architecture."
    },
    {
      question: "Do you support end-to-end deployment?",
      answer: "Yes, we provide complete support including hardware integration, AI model deployment, dashboard development, system integration, monitoring tools, training, and post-deployment maintenance."
    },
    {
      question: "Can your solutions work in remote or challenging terrains?",
      answer: "Yes, our systems are optimized for highways, hilly regions, rural roads, pilgrimage routes, and other low-connectivity environments using edge computing and efficient data pipelines."
    },
    {
      question: "Do you collaborate with academic or research institutions?",
      answer: "Yes, we actively collaborate with universities and research organizations to translate advanced research into deployable technology solutions. The systems originated from research projects at IIT Roorkee."
    },
    {
      question: "Can your systems integrate with existing infrastructure?",
      answer: "Yes, our solutions are designed to integrate seamlessly with existing traffic and transport infrastructures with ease."
    },
    {
      question: "How can we partner with Parimitra?",
      answer: "You can partner with us through pilot projects, research collaborations, technology licensing, smart city integrations, or customized AI solution development initiatives."
    }
];


  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const [formInput, setFormInput] = useState({
    firstName: "",
    lastName: "",
    email: "",
    organization: "",
    projectType: "",
    message: "",
  });

  const handleChange = (e) => {
    const fieldName = e.target.name;
    const value = e.target.value;

    setFormInput({ ...formInput, [fieldName]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const firstName = formInput.firstName.trim();
    const lastName = formInput.lastName.trim();
    const email = formInput.email.trim();
    const organization = formInput.organization.trim();
    const projectType = formInput.projectType;
    const message = formInput.message.trim();

    if (firstName === "" || email === "" || message === "") {
      alert("Please fill in all required fields.");
      return;
    }

    send("service_led1pu5", "template_rn5uu5v", {
      from_name: `${firstName} ${lastName}`,
      email: email,
      organization: organization,
      project_type: projectType,
      message: message,
    }, "vxnrW3XR0nAlTW9fm").then(
      (res) => {
        alert("Email Sent");
        window.location.reload();
      },
      (err) => {
        alert(`Something went wrong. Please try again later.\n\nError: ${err.text || err.message || err}`);
      }
      // (err) => {
      //   alert("Something Went Wrong. Please try again later.");
      //}
    );
  };

  return (
    <>
      <Navbar />
      <main className={`contact-page ${slice.isDark ? "dark-theme" : ""}`}>
        <section className="contactDetails">
          <div className="contact-header">
            <h1>Let's Build Smarter Cities Together</h1>
            <p>
              Ready to transform your city with innovative smart solutions? Get in touch with our
              team of experts and let's create a sustainable future together.
            </p>
          </div>

          <div className="contact-card">
            <div className="contact-info">
              <h2 style={{ textAlign: "center" }}>Get In Touch</h2>
              <p className="info-sublo" style={{ textAlign: "center" }}>We're here to help you build the smart city of tomorrow. Reach out to us and let's start the conversation.</p>

              <div className="info-item">
                <div className="icon-circle">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 13.43C13.7231 13.43 15.12 12.0331 15.12 10.31C15.12 8.58687 13.7231 7.18994 12 7.18994C10.2769 7.18994 8.88 8.58687 8.88 10.31C8.88 12.0331 10.2769 13.43 12 13.43Z" fill="white" />
                    <path d="M3.624 10.836C3.624 6.34795 7.42795 2.54395 11.916 2.54395C16.44 2.54395 20.208 6.34795 20.208 10.836C20.208 15.204 15.684 21.0599 12.924 21.048C10.74 21.036 3.624 15.3 3.624 10.836ZM12 14.7599C14.472 14.7599 16.488 12.744 16.488 10.2719C16.488 7.79995 14.472 5.78395 12 5.78395C9.52795 5.78395 7.51195 7.79995 7.51195 10.2719C7.51195 12.744 9.52795 14.7599 12 14.7599Z" fill="white" />
                  </svg>
                </div>
                <div className="info-text">
                  <h3>Headquarters</h3>
                  <p>Roorkee, Uttarakhand</p>
                </div>
              </div>

              <div className="info-item">
                <div className="icon-circle">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.01 15.38C18.8 15.38 17.64 15.18 16.55 14.82C16.21 14.71 15.82 14.8 15.56 15.06L14.07 16.95C11.55 15.68 9.29 13.45 8.01 10.9L9.89 9.38997C10.15 9.12997 10.24 8.74997 10.13 8.39997C9.77 7.30997 9.58 6.14997 9.58 4.93997C9.58 4.41997 9.16 3.99997 8.64 3.99997H4.63C4.11 3.99997 3.62 4.47997 3.68 5.60997C4.13 14.53 11.48 21.75 20.45 20.98C21.57 20.89 22 20.4 22 19.89V16.33C22 15.8 21.58 15.38 21.06 15.38H20.01Z" fill="white" />
                  </svg>
                </div>
                <div className="info-text">
                  <h3>Phone</h3>
                  <p>+91 9495050608</p>
                </div>
              </div>

              <div className="info-item">
                <div className="icon-circle">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="white" />
                  </svg>
                </div>
                <div className="info-text">
                  <h3>Email</h3>
                  <p>support@parimitra.in</p>
                </div>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="flex-row">
                <div className="formfield">
                  <label>First Name</label>
                  <input name="firstName" type="text" placeholder="Enter your first name" onChange={handleChange} required />
                </div>
                <div className="formfield">
                  <label>Last Name</label>
                  <input name="lastName" type="text" placeholder="Enter your last name" onChange={handleChange} required />
                </div>
              </div>

              <div className="formfield">
                <label>Email Address</label>
                <input name="email" type="email" placeholder="Enter your email address" onChange={handleChange} required />
              </div>

              <div className="formfield">
                <label>Organization</label>
                <input name="organization" type="text" placeholder="Enter your organization name" onChange={handleChange} />
              </div>

              <div className="formfield">
                <label>Project Type</label>
                <select name="projectType" onChange={handleChange} className="form-select">
                  <option value="">Select project type</option>
                  <option value="smart-traffic">Smart Traffic Management</option>
                  <option value="public-transit">Public Transit Optimization</option>
                  <option value="crowd-analytics">Crowd Analytics</option>
                  <option value="consulting">Consulting</option>
                  <option value="others">Others</option>
                </select>
              </div>

              <div className="formfield">
                <label>Message</label>
                <textarea name="message" placeholder="Tell us about your project requirements..." onChange={handleChange} required></textarea>
              </div>

              <button type="submit">
                Send Message
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '8px' }}>
                  <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 5L19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </form>
          </div>
        </section>

        {/* Locations Section
        <section className="locations-section">
          <div className="section-header">
            <h2>Our Locations</h2>
            <p>Find us across major smart cities worldwide</p>
          </div>
          <div className="map-placeholder">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18V5L12 7L15 5V18L12 20L9 18Z" fill="#a1a1aa" opacity="0.5" />
              <path d="M9 18L3 20V7L9 5V18ZM15 18V5L21 7V20L15 18Z" stroke="#a1a1aa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Interactive map coming soon</span>
          </div>
        </section> */}

        {/* FAQ Section */}
        <section className="faq-section">
          <div className="section-header">
            <h2>Frequently Asked Questions</h2>
            <p>Get answers to common questions about our smart city solutions</p>
          </div>
          <div className="faq-container">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                onClick={() => toggleFAQ(index)}
              >
                <div className="faq-question">
                  <h3>{faq.question}</h3>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="faq-icon"
                  >
                    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

export default Contact
